import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import Select, { createFilter } from 'react-select';
import { FixedSizeList as List } from 'react-window';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const height = 35;

const MenuList = props => {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;
  const childCount = React.Children.count(children);
  const computedHeight = Math.min(maxHeight, Math.max(childCount, 1) * height);
  return (
    <List
      height={computedHeight}
      itemCount={childCount}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

MenuList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
  maxHeight: PropTypes.number.isRequired,
  getValue: PropTypes.func.isRequired
};

const MultiSelect = ({ label, options, updateFilters, value }) => {
  const {
    ORDERS: { selectLabel }
  } = useLocalizedStringsContext();
  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 100,
      color: '#222',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  };

  return (
    <div className="dropdown-main-container">
      <Typography heading="h4" variant={{ size: 'h4' }} block>{label}</Typography>
      <div className="dropdown-container">
        <Select
          placeholder={`${selectLabel}...`}
          value={value}
          styles={styles}
          components={{ MenuList }}
          options={options}
          isMulti
          filterOption={createFilter({ ignoreAccents: false })}
          onChange={selectedValue => {
            updateFilters(selectedValue);
          }}
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        />
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default MultiSelect;
